import { render, staticRenderFns } from "./IndependentEmergencyRoomPhysiciansTrust.vue?vue&type=template&id=51f80ade&scoped=true&"
import script from "./IndependentEmergencyRoomPhysiciansTrust.vue?vue&type=script&lang=js&"
export * from "./IndependentEmergencyRoomPhysiciansTrust.vue?vue&type=script&lang=js&"
import style0 from "./IndependentEmergencyRoomPhysiciansTrust.vue?vue&type=style&index=0&id=51f80ade&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f80ade",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VCol,VDivider,VFileInput,VForm,VIcon,VRow})
